<template>
  <donut-slack-preview :class="milestone.active || props.editable ? '' : 'o-50'">
    <div class="block"><div v-slack-format="displayText" class="text" /></div>
    <div class="block"><div class="divider" /></div>
    <div class="block"><div v-slack-format="pointsText" class="text" /></div>
    <div v-if="displayGifUrl" class="block"><img class="w-100p" :src="displayGifUrl"></div>
    <div class="block">
      <div class="actions">
        <div v-for="(button, i) in displayButtons" :key="`button-${i}`" v-emoji="button" class="action dark unpressable" />
      </div>
    </div>
  </donut-slack-preview>
</template>

<script setup>
  import { computed, inject } from 'vue';
  import { useStore } from 'vuex';
  import { capitalize } from 'lodash';
  import useStringFormatting from 'composables/string-formatting';

  const { state, getters } = useStore();
  const { toOrdinal } = useStringFormatting();
  const $i18n = inject('$i18n');
  const props = defineProps({
    editable: { type: Boolean, default: false },
    message: { type: String, default: null },
    gifUrl: { type: String, default: null },
    milestoneType: { type: String, required: true },
  });

  const milestone = computed(() => state.bonusMilestoneConfigs[props.milestoneType]);
  const displayText = computed(() => (props.editable ? props.message : milestone.value.message));
  const displayGifUrl = computed(() => (props.editable ? props.gifUrl : milestone.value.image_url));
  const displayButtons = computed(() => [
      ':gift: Redeem',
      `:${state.pointsConfig.config.emoji}: See My ${capitalize($i18n.t('shoutouts.point', { count: 2 }))}`,
    ]);
  const pointsText = computed(() => {
    const pby = milestone.value.points_by_year || {};
    const dp = milestone.value.default_points;
    const usesTiers = milestone.value.amount_mode !== 'default_only';
    const usesDefault = milestone.value.amount_mode !== 'custom_only';

    const displayYear = usesDefault ? 1 : Math.min(...Object.keys(pby));
    let eventName;
    let numPoints;
    if (props.milestoneType === 'anniversary') {
      eventName = `your ${toOrdinal(displayYear)} year at ${state.currentTeam.name}`;
      numPoints = (usesTiers && pby[displayYear]) || dp;
    } else if (props.milestoneType === 'birthday') {
      eventName = 'your birthday';
      numPoints = dp;
    }

    return `Here ${numPoints === 1 ? 'is' : 'are'} *${getters['pointsConfig/pointsPhraseFromConfig']({ points: numPoints })}* `
      + `to celebrate ${eventName}! *${getters['pointsConfig/pointsPhraseFromConfig']({})}* can be redeemed in the `
      + `${$i18n.t('shoutouts.rewards_store')}.`;
  });
</script>
